import React from 'react';
import GameCard from '../GameCard';
import styles from './GamesGrid.module.sass';

const GamesGrid = ({ gamesData = [], onGameClick }) => {
    return (
        <div className={styles.gamesGrid}>
            {gamesData.map((gameData) => (
                <GameCard key={gameData.name} gameData={gameData} onClick={onGameClick} />
            ))}
        </div>
    );
};

export default GamesGrid;
